/**
 * Parse the validation error from the server into a flattened array of messages.
 *
 * @param  {Object}  error  The error object in JSON format.
 *
 * @return {Array.<String>}
 */
export default function (error) {
    return Object.keys(error).reduce((messages, field) => messages.concat(error[field]), [])
}
